import React, { PureComponent } from "react";
import {
  renderLegends,
  TableContentCell,
  TableColumnBarChart,
  sortNumeric,
  selectFormat,
  getMetricForColumn,
} from "./../Utils/Utils.js";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

/**
 * To examine how people maintain interest over the course of a season
 */
class SeasonViewingCompletion extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  // renders the chart in the column
  chart = (cell, row) => (
    <TableColumnBarChart
      title={cell}
      row={row}
      bar_chart_data={row.data}
      isResponsive={true}
    />
  );

  // wrapper to render the thumbnail without title
  thumbnailWithoutTitle = (cell, row) =>
    TableContentCell(cell, row, null, null, false);

  builtInExportCSV = () => this.childRef;

  render() {
    const { data, chart, title } = this.props;

    const pagination = paginationFactory({
      sizePerPage: 10,
      hideSizePerPage: true,
    });

    // prepare the data to create the graph
    data.data.forEach((d, idx) => {
      // sum all viewers
      for (let i in d.data) {
        d.data[i] = {
          value: d.data[i].views_unique.value,
          type: "views_unique",
        };
      }
      d.id = idx;
    });

    // prepare the columns for the table
    const columns = [
      {
        dataField: "title",
        text: "Title",
        style: { width: "250px", minWidth: "250px", textAlign: "left" },
        headerAlign: "left",
        formatter: TableContentCell,
        csvFormatter: (cell, row) => row && (row.title || ""),
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
        sort: true,
      },
      {
        dataField: "genre",
        text: "Genre",
        style: { width: "100px", minWidth: "100px", textAlign: "left" },
        headerAlign: "left",
        csvFormatter: (cell) => cell,
        sort: true,
      },
      {
        dataField: "release_date",
        text: "Earliest Release",
        headerAlign: "left",
        csvFormatter: (cell) => cell,
        sort: true,
      },
      {
        dataField: "views_unique",
        text: "Unique viewers",
        style: { minWidth: "200px", textAlign: "center" },
        headerAlign: "left",
        csvFormatter: (_, row) => {
          let episodes = [];
          row.data.map((e) => {
            return episodes.push(e.value);
          });
          return episodes.join(", ");
        },
        formatter: (cell, row) => this.chart(cell, row),
        sort: false,
      },
      {
        dataField: "start_to_finish_ratio",
        text: "Start To Finish Ratiio",
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage", format: "%0.00" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "%0.00"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "lifetime_uv",
        text: "Lifetime UVs",
        sort: true,
        sortFunc: sortNumeric,
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
        formatExtraData: { type: "number" },
      },
      {
        dataField: "lifetime_min",
        text: "Lifetime Min",
        sort: true,
        sortFunc: sortNumeric,
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
        formatExtraData: { type: "number" },
      },
      // {
      //   dataField: "rollout_window",
      //   text: "Rollout Window (in Days)",
      //   sort: true,
      //   formatter: getMetricForColumn,
      //   csvFormatter: (cell) =>
      //     selectFormat("csv_number", cell && cell.value, "0.0"),
      //   sortFunc: sortNumeric,
      //   formatExtraData: { type: "number" },
      // },
    ];

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <>
        {chart &&
          renderLegends(["E1", "E2", "E3", "E4", "E5", "E6", "E7", "E8"])}

        <ToolkitProvider
          keyField="id"
          data={data.data}
          columns={columns}
          exportCSV={{
            fileName: filename + ".csv",
            exportAll: false,
            onlyExportFiltered: true,
          }}
        >
          {(props) => (
            <BootstrapTable
              {...props.baseProps}
              {...props.csvProps}
              ref={(el) => (this.childRef = el)}
              pagination={pagination}
              filter={filterFactory()}
              defaultSorted={[
                {
                  dataField: "release_date",
                  order: "desc",
                },
              ]}
            />
          )}
        </ToolkitProvider>
      </>
    );
  }
}

export default SeasonViewingCompletion;
